export const requestConfig = {
  title: "Date Operator Economic",
};
